<template>
  <div v-if="showModelInfo" v-zpm="{ sectionid: 163, areaexposure: 163 }" class="rank-info">
    <!-- 品牌介绍 -->
    <div
      v-if="rankInfo.modelBrandInfo && rankInfo.modelBrandInfo.brandName"
      v-zpm="{ sortid: 0, sortname: '品牌' }"
      class="cate-intro"
      @click="jumpUrl"
    >
      <img class="cate-icon" :src="$setPicSize(rankInfo.modelBrandInfo.logo)" />
      <span class="cate-name">{{ rankInfo.modelBrandInfo.brandName }}</span>
      <span class="line"></span>
      <span class="cate-desc">{{ rankInfo.modelBrandInfo.tagName }}</span>
      <img
        :src="
          $setPicSize(
            'https://pic5.zhuanstatic.com/zhuanzh/ae2cebb0-f5e1-4d38-bb7a-8a6230f3ec91.png'
          )
        "
        alt=""
        class="arrow"
      />
    </div>

    <!-- 尖货商品 -->
    <div
      v-if="rankInfo.topGoodInfo"
      v-zpm="{ sortid: 1, sortname: '尖货' }"
      class="rank-info-left topGoodInfo"
      @click="$refs.refSharpGoodsPopup.popupStatus()"
    >
      <img
        class="tag"
        :src="
          $setPicSize(
            rankInfo.topGoodInfo.logo ||
              'https://pic4.zhuanstatic.com/zhuanzh/00236c72-34e6-4af5-9741-6e900f81632c.png',
            24
          )
        "
      />

      <span class="desc">{{ rankInfo.topGoodInfo.name || '尖货' }}</span>
      <img
        class="arrow"
        :src="
          $setPicSize(
            'https://pic5.zhuanstatic.com/zhuanzh/ae2cebb0-f5e1-4d38-bb7a-8a6230f3ec91.png'
          )
        "
        alt=""
      />
    </div>
    <!-- 榜单入口 -->
    <div
      v-if="rankInfo.rankInfo"
      v-zpm="{ sortid: 2, sortname: '榜单' }"
      class="rank-info-left"
      @click="gotoPage"
    >
      <img
        class="tag"
        :src="
          $setPicSize(
            'https://pic4.zhuanstatic.com/zhuanzh/2322ae3e-1c10-4671-9e1b-322a218e7fef.png'
          )
        "
      />

      <span class="desc">{{ rankInfo.rankInfo }}</span>
      <img
        v-if="rankInfo.linkUrl"
        class="arrow"
        :src="
          $setPicSize(
            'https://pic5.zhuanstatic.com/zhuanzh/ae2cebb0-f5e1-4d38-bb7a-8a6230f3ec91.png'
          )
        "
        alt=""
      />
    </div>

    <!-- 备件库 -->
    <div
      v-if="rankInfo.sourceInfo"
      v-zpm="{ sortid: 3, sortname: rankInfo.sourceInfo.sourceName }"
      class="cate-intro bs"
      @click="$refs.sparePartPopup.sparePartsShow = true"
    >
      <img
        v-if="rankInfo.sourceInfo.titleIcon"
        class="cate-icon"
        :src="$setPicSize(rankInfo.sourceInfo.titleIcon)"
      />
      <span class="cate-name">{{ rankInfo.sourceInfo.sourceName }}</span>
      <img
        :src="
          $setPicSize(
            'https://pic5.zhuanstatic.com/zhuanzh/ae2cebb0-f5e1-4d38-bb7a-8a6230f3ec91.png'
          )
        "
        alt=""
        class="arrow"
      />
    </div>
    <!-- 备件库弹窗 -->
    <spare-parts-popup
      v-if="rankInfo.sourceInfo"
      ref="sparePartPopup"
      :title="rankInfo.sourceInfo.sourceName"
      :sourceInfo="rankInfo.sourceInfo"
      :dataInfo="dataInfo"
      :visibilityState="visibilityState"
    ></spare-parts-popup>
    <!-- 尖货弹窗 -->
    <sharpGoodsPopup
      v-if="rankInfo.topGoodInfo"
      ref="refSharpGoodsPopup"
      :topGoodInfo="rankInfo.topGoodInfo"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import { Dialog } from '@zz-common/zz-ui'
import { defineComponent, computed, onMounted, ref } from '@vue/composition-api'
import { skipToUrl } from '@utils/native'
import sparePartsPopup from './spare-parts-popup.vue'
import sharpGoodsPopup from './sharp-goods-popup.vue'
import { state } from '@/store/index'

Vue.use(Dialog)
export default defineComponent({
  components: {
    sparePartsPopup,
    sharpGoodsPopup
  },
  props: {
    rankInfo: {
      type: Object,
      default: () => {}
    },
    dataInfo: {
      type: Object,
      default: () => {}
    },
    visibilityState: {
      type: String,
      default: ''
    }
  },
  setup(props, ctx) {
    const { $legoAreaExposure } = ctx.root
    const sparePartPopup = ref(null)
    const refSharpGoodsPopup = ref(null) // 尖货弹窗元素
    const gotoPage = () => {
      const targetUrl = props.rankInfo.linkUrl
      targetUrl &&
        skipToUrl({
          targetUrl
        })
    }

    onMounted(() => {
      $legoAreaExposure()
    })

    /**
     * $ 是否展示模块(品牌、榜单、备件库、尖货)
     */
    const showModelInfo = computed(() => {
      return (
        props.rankInfo.modelBrandInfo ||
        props.rankInfo.rankInfo ||
        props.rankInfo.sourceInfo ||
        props.rankInfo.topGoodInfo
      )
    })

    const jumpUrl = () => {
      const brandId = state.brandId
      const url = `https://act.zhuanzhuan.com/platform/zz-platform-pages/brand-mark-intro?needHideHead=3&wvCornerRadius=32&wvHalfVer=v2&wvHeightRate=0.8&channel&brandId=${brandId}`
      skipToUrl({
        targetUrl: url
      })
    }

    return {
      gotoPage,
      jumpUrl,
      sparePartPopup,
      showModelInfo,
      refSharpGoodsPopup
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
.rank-info {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 12px;
  margin-bottom: 28px;
  overflow-x: scroll;
  overflow-y: hidden;
  color: #111111;
  font-size: 22px;
  font-family: PingFangSC-Light, PingFang SC;
  line-height: 22px;
  &::-webkit-scrollbar {
    display: none;
  }

  .cate-intro {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: 36px;
    margin-right: 8px;
    padding: 0 10px;
    white-space: nowrap;
    background: #ffffff;
    border-radius: 4px;
    // &.bs {
    //   margin-left: 8px;
    // }

    .cate-icon {
      max-width: 40px;
      height: 24px;
      margin-right: 6px;
    }
    .line {
      position: relative;
      display: inline-block;
      width: 1px;
      height: 16px;
      margin: 0 12px;

      &::after {
        @include hairline(#c6c6c6);
        border-left-width: 1px;
      }
    }
  }

  .arrow {
    width: 9px;
    height: 16px;
    margin-left: 6px;
  }
  .rank-info-left {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: 36px;
    margin-right: 8px;
    padding: 7px 10px;
    background: #ffffff;
    border-radius: 4px;
    .tag {
      width: 17px;
      margin-right: 6px;
    }
    .title {
      font-weight: 500;
      font-family: PingFangSC-Medium, PingFang SC;
    }
    .desc {
      // width: 450px;
      overflow: hidden;
      font-weight: 300;
      font-family: PingFangSC-Light, PingFang SC;
      white-space: nowrap;
    }
  }
}
</style>
